module.exports = __webpack_public_path__ + "img/main.55984b35.png";